var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

function showAccessDeniedModal() {

    const currentPage = window.location.href;
    const excludedPage = 'https://contempocrystals.com/pages/international-orders';

    if (currentPage === excludedPage) {
        return;
    }
    const overlay = document.createElement('div');
    const modal = document.createElement('div');
    Object.assign(overlay.style, {
        backgroundColor: 'rgb(0 0 0 / 40%)',
        position: 'fixed',
        display: 'block',
        zIndex: '9999',
        width: '100%',
        height: '100%'
    });
  
    if (window.innerWidth < 600) {
        Object.assign(modal.style, {
            top: '10%',
            left: '10%',
            width: '80%',  
            height: '90%', 
            paddingBottom: '15px'
        });
    } else {
        Object.assign(modal.style, {
            top: '30%',
            left: '30%',
            width: '40%',
            height: '40%'
        });
    }

    Object.assign(modal.style, {
        backgroundColor: 'white',
        color: 'black',
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        zIndex: '9999',
        pointerEvents: 'auto',
        borderRadius: '10px',
        overflowY: 'auto',
        border: 'solid 1px black'
    });

    document.body.style.overflow = 'hidden';

    const originalCursor = document.body.style.cursor;

    const content = document.createElement('div');
    content.style.padding = '20px';

    const header = document.createElement('h1');
    header.textContent = 'Attention';
    header.style.fontSize = window.innerWidth < 600 ? '1.5em' : '2.5em';
    header.style.marginTop = '0';
    content.appendChild(header);

    const message = document.createElement('p');
    message.innerHTML = `
        Hello! Thank you for your interest in my shop. Please note that we are only able to ship to North American addresses.
        Please click the button below to learn more about international orders. Thank you!
    `;
    message.style.maxWidth = '80%';
    message.style.lineHeight = '1.5';
    message.style.margin = 'auto';
    content.appendChild(message);

    const closeButton = document.createElement('button');
    closeButton.textContent = 'X';
    Object.assign(closeButton.style, {
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: 'white',
        color: 'black',
        padding: '10px',
        cursor: 'pointer',
        border: 'none'
    });

    closeButton.onclick = function () {
        document.body.removeChild(overlay);
        document.body.removeChild(modal);
        document.body.style.cursor = originalCursor;
        document.body.style.overflow = '';
    };

    const learnMoreButton = document.createElement('a');
    learnMoreButton.href = 'https://contempocrystals.com/pages/international-orders';
    learnMoreButton.textContent = 'LEARN MORE';
    Object.assign(learnMoreButton.style, {
        marginTop: '20px',
        padding: '10px 20px',
        backgroundColor: '#50cecd',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    });

    modal.appendChild(closeButton);
    modal.appendChild(content);
    modal.appendChild(learnMoreButton);
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
}

const countries = [
  "Canada",
  "United States of America"
];

var country = getCountry();
console.log(country);

// Check if the popup has already been shown in this session
if (!countries.includes(country) && !sessionStorage.getItem('popupShown')) {
  setTimeout(() => {
    showAccessDeniedModal();
    // Set a flag in sessionStorage to remember that the popup has been shown
    sessionStorage.setItem('popupShown', 'true');
  }, 20000);
}
